// extracted by mini-css-extract-plugin
export var compactFilters = "_hc-4";
export var detailImage = "_hc-1";
export var dropdownContainer = "_hc-2";
export var imageContainer = "_hc-0";
export var selectedCard = "_hc-3";